import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
// eslint-disable-next-line no-unused-vars
import { AlertProps } from "@mui/material/Alert"; // Only used for JSDoc comment

/**
 * Dialog for toast messages.
 * @param {object} props
 * @param {boolean} props.show `true` to open the toast and `false` to close it.
 * @param {string} props.message The message to display.
 * @param {"info" | "success" | "warning" | "error"} props.type The type of toast.
 * @param {AlertProps["onClose"]} props.handleClose Called when the toast requests to be closed.
 */
const Toast = ({ show, type, message, handleClose }) => {
    return (
        <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            open={show}
            autoHideDuration={6000}
            onClose={handleClose}
        >
            <Alert onClose={handleClose} severity={type} sx={{ width: "100%" }}>
                {message}
            </Alert>
        </Snackbar>
    );
};

export default Toast;
